import { combineReducers } from '@reduxjs/toolkit';
import bootstrapSlice from './slices/BootstrapSlice';
import installationSlice from './slices/InstallationSlice';
import organisationSlice from './slices/OrganisationSlice';
import userSlice from './slices/UserSlice';
import connectionSlice from './slices/ConnectionSlice';

const rootReducer = combineReducers({
    bootstrap: bootstrapSlice,
    installation: installationSlice,
    organisation: organisationSlice,
    user: userSlice,
    connection: connectionSlice,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
